'use strict';
import actionAjaxUrl from '../util/actionAjaxUrl.js';
import objectIsEmpty from '../util/objectIsEmpty.js';
import getCookie from '../util/getCookie.js';

class RDStationService {
    constructor (
        customer = {},
        plan = {},
        activeSubscriptionsLength = 0
    ) {
        this._customer = customer;
        this._plan = plan;
        this._dataRDstation = {
            contacts: {},
        };
        this._activeSubscriptionsLength = activeSubscriptionsLength;
    }

    set customer (newValue) {
        this._customer = newValue;
    }

    set plan (newValue) {
        this._plan = newValue;
    }

    set activeSubscriptionsLength (newValue) {
        this._activeSubscriptionsLength = newValue;
    }

    sendEventConversion (data) {
        return new Promise(function (resolve, reject) {
            try {
                $.ajax({
                    data: data,
                    method: 'POST',
                    url: actionAjaxUrl('rdstation_send_event_conversion'),
                })
                    .done((response) => {
                        return resolve(response);
                    })
                    .fail((response) => {
                        return reject(response);
                    });
            } catch (error) {
                console.error(error);
            }
        });
    }

    sendEventConversionStarted () {
        const self = this;

        let customer = self._customer;

        $.ajax({
            data: {
                conversion_identifier:'iniciou-checkout',
                name: customer.name,
                email: customer.email,
                mobile_phone: customer.phone,
                ...RDStationService.generateBodyParametersTraffic(),
                cf_cf_nome_do_plano_1: self._plan.attributes.name,
            },
            method: 'POST',
            url: actionAjaxUrl('rdstation_send_event_conversion'),
        })
            .done(() => {
                let callback = () => {
                    return self.sendEventOpportunity();
                }

                self.readByEmailContact(callback);
            })
            .fail(() => {
                // TODO BOX-213
            });
    }

    readByEmailContact (callback = () => {}, dataCallback = null) {
        const self = this;

        let customer = self._customer;

        $.ajax({
            data: {
                email: customer.email,
            },
            method: 'GET',
            url: actionAjaxUrl('rdstation_read_by_email_contact'),
        })
            .done((response) => {
                self._dataRDstation.contacts = response;

                if (dataCallback === null) {
                    callback();
                } else {
                    callback(dataCallback);
                }
            })
            .fail(() => {
                setTimeout(() => {
                    if ( typeof self.readByEmailContact.counter == 'undefined' ) {
                        self.readByEmailContact.counter = 0;
                    }

                    ++self.readByEmailContact.counter;

                    if (self.readByEmailContact.counter < 5) {
                        self.readByEmailContact(callback, dataCallback);
                    }
                }, 3000);
            });
    }

    sendEventOpportunity () {
        const self = this;

        let customer = self._customer;

        $.ajax({
            data: {
                email: customer.email,
                funnel_name: 'default',
            },
            method: 'POST',
            url: actionAjaxUrl('rdstation_send_event_opportunity'),
        });
    }

    sendEventConversionFinished () {
        const self = this;
        let tags = ['cliente-ativo'];
        const contacts = self._dataRDstation.contacts;

        if (self._activeSubscriptionsLength > 0) {
            tags.push('recompra');
        }

        const dataUpdate = {
            uuid: contacts.uuid,
            tags: tags,
        }

        var settings = {
            'url': actionAjaxUrl('rdstation_update_contact'),
            'method': 'PATCH',
            'timeout': 0,
            'headers': {
                'Content-Type': 'application/json',
            },
            'data': JSON.stringify(dataUpdate),
        };

        $.ajax(settings);

        let customer = self._customer;

        $.ajax({
            data: {
                conversion_identifier:'finalizou-checkout',
                ...RDStationService.generateBodyParametersTraffic(),
                email: customer.email,
            },
            method: 'POST',
            url: actionAjaxUrl('rdstation_send_event_conversion'),
        })
            .done(() => {
            })
            .fail(() => {
                // TODO BOX-213
            });
    }

    sendEventSale (totalPayment) {
        const self = this;

        let customer = self._customer;

        var settings = {
            url: actionAjaxUrl('rdstation_send_event_sale'),
            method: 'POST',
            timeout: 0,
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify({
                email: customer.email,
                funnel_name: 'default',
                value: totalPayment / 100,
            }),
        };

        $.ajax(settings);
    }

    updateContact (children) {
        const self = this;

        let data = {};
        const profiles = self._plan.relationships.box.data.attributes.profiles;

        let profilesNames = children.map((profile) => {
            for (let i = 0; i < profiles.length; i++ ) {
                if (profiles[i].box_profile_id === profile.box_profile_id) {
                    return profiles[i].name;
                }
            }
        });

        let uniqueProfilesNames = (names) => names.filter((v,i) => names.indexOf(v) === i)

        switch (self._activeSubscriptionsLength) {
            case 0:
                data = {
                    cf_cf_nome_da_categoria_1: uniqueProfilesNames(profilesNames).join(' | '),
                    cf_cf_nome_do_plano_1: self._plan.attributes.name,

                    cf_cf_nome_da_categoria_2: '',
                    cf_cf_nome_do_plano_2: '',

                    cf_cf_nome_da_categoria_3: '',
                    cf_cf_nome_do_plano_3: '',

                    cf_cf_nome_da_categoria_4: '',
                    cf_cf_nome_do_plano_4: '',
                };
                break;
            case 1:
                data = {
                    cf_cf_nome_da_categoria_2: uniqueProfilesNames(profilesNames).join(' | '),
                    cf_cf_nome_do_plano_2: self._plan.attributes.name,
                };
                break;
            case 2:
                data = {
                    cf_cf_nome_da_categoria_3: uniqueProfilesNames(profilesNames).join(' | '),
                    cf_cf_nome_do_plano_3: self._plan.attributes.name,
                };
                break;
            case 3:
            default:
                data = {
                    cf_cf_nome_da_categoria_4: uniqueProfilesNames(profilesNames).join(' | '),
                    cf_cf_nome_do_plano_4: self._plan.attributes.name,
                };
                break;
        }

        try {
            if (objectIsEmpty(self._dataRDstation.contacts)) {
                throw new Error('Lead não registrado no RD station');
            }

            let contacts = self._dataRDstation.contacts;

            Object.assign(data, {uuid: contacts.uuid})

            var settings = {
                'url': actionAjaxUrl('rdstation_update_contact'),
                'method': 'PATCH',
                'timeout': 0,
                'headers': {
                    'Content-Type': 'application/json',
                },
                'data': JSON.stringify(data),
            };

            $.ajax(settings);

            let renewOpportunity = (
                self._activeSubscriptionsLength === 0 &&
                contacts.tags.find(status => status === 'cliente-ativo')
            );

            if (renewOpportunity) {
                self.sendEventOpportunity();
            }



        } catch (e) {
            console.error(e.message)

            let callback = (c) => {
                return self.updateContact(c);
            };

            self.readByEmailContact(callback, children);
        }
    }

    /**
     * @static
     *
     * @return {{
     *      traffic_source: string,
     *      traffic_medium: (string|undefined),
     *      traffic_campaign: (string|undefined),
     *      traffic_value: (string|undefined),
     * }} traffic
     */
    static generateBodyParametersTraffic() {
        let cookieTrafficSource = getCookie('__trf.src');

        const params = new URLSearchParams(window.location.search);

        let traffic = {
            traffic_source: params.get('utm_source'),
            traffic_medium: params.get('utm_medium'),
            traffic_campaign: params.get('utm_campaign'),
            traffic_value: params.get('utm_term'),
        }

        if (cookieTrafficSource !== "") {
            traffic.traffic_source = cookieTrafficSource;

            delete traffic.traffic_medium;
            delete traffic.traffic_campaign;
            delete traffic.traffic_value;
        }

        return traffic;
    }
}

export default RDStationService;



// WEBPACK FOOTER //
// ./scripts/services/RDStationService.js